import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() backgroundColor: string = '#000000';
  @Input() textColor: string = '#ffffff';
  @Input() text: string = 'Click me';
  @Input() width: string = '350px';
  @Output() clicked = new EventEmitter<void>();

  handleClick() {
    this.clicked.emit();
  }
}
